import { render, staticRenderFns } from "./SecurityOverview.vue?vue&type=template&id=4cb0c280&"
import script from "./SecurityOverview.vue?vue&type=script&lang=js&"
export * from "./SecurityOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports